<template>
    <div class="alert" :class="type">
        <div class="content">
            <div class="message">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.alert {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 500;
    position: fixed;
    bottom: 0;
    left: 260px;
    min-height: 50px;
    width: calc(100% - 260px);
    @media(max-width: 768px) {
        left: 0;
        width: 100%;
    }

    .content {
        display: flex;
        align-items: center;
        width: 100%;

        .icon {
            margin-right: 10px;

            i {
                font-size: 20px;
            }
        }

        .message {
            font-size: 16px;
            width: 100%;
            @media(max-width: 768px) {
                font-size: 13px;

            }
        }
    }

    &.success {
        background-color: #d4edda;
        color: #155724;
    }

    &.warning {
        background-color: #fff3cd;
        color: #856404;
    }

    &.error {
        background-color: #f8d7da;
        color: #721c24;
    }
}
</style>
<script>
export default {
    name: "KeviAlert",
    props: {
        type: {
            type: String,
            default: 'success'
        }
    }
}
</script>
